import { render, staticRenderFns } from "./SupportsAppeal.vue?vue&type=template&id=0049c4f8&scoped=true"
import script from "./SupportsAppeal.vue?vue&type=script&lang=js"
export * from "./SupportsAppeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049c4f8",
  null
  
)

export default component.exports